import { z } from 'zod';
import { User, UserSummary } from './User';

export const userListExample = z.array(User).parse([
  // 50人分のデータを作る
  ...Array.from({ length: 50 }, (_, i) => ({
    id: `user-${i}`,
    name: `ユーザー ${i}`,
    avatarURL: 'https://picsum.photos/200/200',
    bio: `ユーザー ${i} の自己紹介`,
    role: 'normal',
    lastLoginAt: '2021-02-01T00:00:00.000+09:00',
    createdAt: '2021-02-01T00:00:00.000+09:00',
    updatedAt: '2021-02-01T00:00:00.000+09:00',
  })),
  {
    id: 'user-50',
    name: 'リーダー',
    avatarURL: 'https://picsum.photos/200/200',
    bio: 'リーダーの自己紹介',
    role: 'leader',
    lastLoginAt: '2021-02-01T00:00:00.000+09:00',
    createdAt: '2021-02-01T00:00:00.000+09:00',
    updatedAt: '2021-02-01T00:00:00.000+09:00',
  },
]);

export const userSummaryListExample = z
  .array(UserSummary)
  .parse(userListExample);
